import { render, staticRenderFns } from "./DecisoriosbyProcesso.vue?vue&type=template&id=8c6952a2&scoped=true&"
import script from "./DecisoriosbyProcesso.vue?vue&type=script&lang=js&"
export * from "./DecisoriosbyProcesso.vue?vue&type=script&lang=js&"
import style0 from "./DecisoriosbyProcesso.vue?vue&type=style&index=0&id=8c6952a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6952a2",
  null
  
)

export default component.exports